<script type="text/jsx">
import partnerConfigBase from '@/views/config/partner-refer/component/partner-config-base.vue';

export default {
  extends: partnerConfigBase,
};
</script>
